import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import styles from "./style";
import { IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { LoadingButton } from "@mui/lab";
import { Box } from "@mui/material";

export default function Modal({ title, loading, children, setOpen, open, handleCheck, handleDelete, btnText, disabled, disableBtn, approveTxt, handleRequest, deletetText, cancelText, setEmployeeData, modalStyle, status }) {
  const handleClose = () => {
    setOpen(false);
    if (setEmployeeData) {
      setEmployeeData([]);
    }
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <React.Fragment>
      {/* <Slide direction="up" in={open} mountOnEnter unmountOnExit> */}
      <Dialog
        open={open}
        onClose={handleClose}
        scroll={"paper"}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        sx={modalStyle || styles.modalPaper}
      >
        <Box sx={styles.titleGrid}>
          <DialogTitle id="scroll-dialog-title" sx={styles.title}>{title}
            {approveTxt && <DialogActions sx={{ ...styles.actionBtn, justifyContent: "flex-end", paddingBottom: "7px", marginRight: "40px" }}>
              {status === "Pending" ? (
                <>
                  <Button type="button" onClick={() => handleRequest("Rejected")} sx={styles.reject} >{"Reject"}</Button>
                  <Button type="button" onClick={() => handleRequest("Approved")} sx={styles.approve} >{"Approve"}</Button>
                </>
              ) : status === "Approved" ? (
                <>
                  <Button type="button" onClick={() => handleRequest("Rejected")} sx={styles.reject} >{"Reject"}</Button>
                </>
              ) : status === "Rejected" ? (
                <>
                  <Button type="button" onClick={() => handleRequest("Approved")} sx={styles.approve} >{"Approve"}</Button>
                </>
              ) : null}
            </DialogActions>}
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={styles.closeIcon}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        <DialogContent dividers={scroll === "paper"}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            <form >
              {children}
            </form>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={styles.actionBtn2}>
          {/* <Button onClick={handleClose} sx={{textTransform: "none" }} >Cancel</Button> */}
          {btnText && (
            <LoadingButton loading={loading} type="submit" onClick={handleCheck} disabled={disabled} sx={disabled ? styles.buttonDisable : styles.button} >{btnText}</LoadingButton>
          )}
          {deletetText && (

            <LoadingButton loading={loading} type="submit" onClick={handleDelete} sx={styles.deletebutton} >{deletetText}</LoadingButton>
          )}
          {cancelText && (

            <LoadingButton loading={loading} type="submit" onClick={handleClose} sx={styles.cancelbutton} >{cancelText}</LoadingButton>
          )}

        </DialogActions>
      </Dialog>
      {/* </Slide>    */}
    </React.Fragment>
  );
}
